import React from "react";
import { MealTypeMacrosTotais } from "../types";

interface MacrosSummaryProps {
  macros: MealTypeMacrosTotais;
}

export default function MacrosSummary({ macros }: MacrosSummaryProps) {
  if (!macros || macros.proteina_g === 0) return null;

  return (
    <div className="mb-4 sm:mb-6 rounded-lg sm:rounded-xl border border-purple-200 bg-purple-50 p-4 sm:p-5 dark:border-purple-800 dark:bg-purple-900/20">
      <p className="mb-3 text-xs font-semibold uppercase tracking-wide text-purple-700 dark:text-purple-300">
        Macronutrientes Totais (TACO)
      </p>
      <div className="grid grid-cols-2 gap-3 sm:grid-cols-4 sm:gap-4">
        <div className="rounded-lg bg-white p-2.5 sm:p-3 dark:bg-boxdark">
          <p className="text-xs text-gray-500 dark:text-gray-400">Proteína</p>
          <p className="text-base sm:text-lg font-bold text-blue-600 dark:text-blue-400">
            {macros.proteina_g.toLocaleString("pt-BR", {
              maximumFractionDigits: 1,
            })}
            g
          </p>
        </div>
        <div className="rounded-lg bg-white p-2.5 sm:p-3 dark:bg-boxdark">
          <p className="text-xs text-gray-500 dark:text-gray-400">
            Carboidrato
          </p>
          <p className="text-base sm:text-lg font-bold text-amber-600 dark:text-amber-400">
            {macros.carboidrato_g.toLocaleString("pt-BR", {
              maximumFractionDigits: 1,
            })}
            g
          </p>
        </div>
        <div className="rounded-lg bg-white p-2.5 sm:p-3 dark:bg-boxdark">
          <p className="text-xs text-gray-500 dark:text-gray-400">Gordura</p>
          <p className="text-base sm:text-lg font-bold text-red-600 dark:text-red-400">
            {macros.lipideos_g.toLocaleString("pt-BR", {
              maximumFractionDigits: 1,
            })}
            g
          </p>
        </div>
        <div className="rounded-lg bg-white p-2.5 sm:p-3 dark:bg-boxdark">
          <p className="text-xs text-gray-500 dark:text-gray-400">Fibra</p>
          <p className="text-base sm:text-lg font-bold text-green-600 dark:text-green-400">
            {macros.fibra_alimentar_g.toLocaleString("pt-BR", {
              maximumFractionDigits: 1,
            })}
            g
          </p>
        </div>
      </div>
    </div>
  );
}
